var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-count-input',{attrs:{"min":0,"disabled":false}})],1),_c('Card',[_c('ui-count-input',{attrs:{"disabled":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }